import { faArrowRotateRight } from "@fortawesome/free-solid-svg-icons/faArrowRotateRight";
import React, { ChangeEvent } from "react";
import { useTranslation } from "react-i18next";
import styled from "styled-components";

import { Spacing } from "../../theme/Spacing";
import { Button } from "../Button";
import { Flex } from "../Flex";
import { Input } from "../Input";

export const TABLE_SEARCH_DEBOUNCE_MS = 1500;

const StyledIconButton = styled(Button)<{ disabled?: boolean }>`
  background-color: transparent;
  padding: 0;
  margin: 0;
  opacity: ${(props) => (props.disabled ? 0.5 : 1)};
  color: ${(props) => props.theme.main};
  &:hover {
    color: ${(props) => props.theme.lightMain};
  }
`;

const Wrapper = styled(Flex)`
  width: 100%;
  align-items: center;
  flex-wrap: nowrap;
  justify-content: space-between;
`;

const SearchAndRefreshWrapper = styled(Flex)`
  align-items: center;
  gap: ${Spacing.s};
  order: 1;
  width: fit-content;
`;

const FiltersWrapper = styled(Flex)`
  flex: 1;
  order: 2;
  align-items: center;
  gap: ${Spacing.s};
  height: 3rem;
  overflow-x: auto;
  min-width: 0;
  padding: 0 ${Spacing.s};

  scrollbar-width: none;
  -ms-overflow-style: none;

  &::-webkit-scrollbar {
    display: none;
  }
`;

type TableHeaderProps = {
  onFetch: VoidFunction;
  onFetchLoading?: boolean;
  onSearch: ATVoidFunction<ChangeEvent<HTMLInputElement>>;
  searchTestId?: string;

  filters?: React.ReactNode;
  showFilters: boolean;
  filtersWrapperStyle?: React.CSSProperties;
};

export const TableHeader: React.FC<TableHeaderProps> = ({
  onFetch,
  onFetchLoading,
  onSearch,
  searchTestId,
  filters,
  showFilters = true,
  filtersWrapperStyle,
}) => {
  const { t } = useTranslation();

  if (!showFilters) {
    return null;
  }

  return (
    <Wrapper>
      <SearchAndRefreshWrapper>
        <StyledIconButton
          onClick={() => {
            // do not remove this arrow function
            onFetch();
          }}
          disabled={onFetchLoading}
          icon={faArrowRotateRight}
          iconWidth="2x"
          padding="xxl"
        />

        <Input
          width="8rem"
          placeholder={t("common.search")}
          onChange={onSearch}
          type="search"
          dataTestId={searchTestId}
        />
      </SearchAndRefreshWrapper>

      <FiltersWrapper style={filtersWrapperStyle}>{filters}</FiltersWrapper>
    </Wrapper>
  );
};
